import { qs, on } from '../lib/dom.js';
import { AP_DATA } from '../data/listings.js';
import { renderListingsInto } from '../components/listing-card.js';
import { initGallery, initSpecsTabs } from '../components/gallery.js';
import { initFinanceCalc } from '../components/finance-calc.js';
import { initFuelCalc } from '../components/fuel-calc.js';
import { getFavs } from '../components/favorites.js';

// The mobile sticky CTA mirrors the header inversely on the listing page:
//   - Scroll DOWN past the title-card → CTA takes the top spot (header is
//     hidden by nav.js's auto-hide on scroll-down).
//   - Scroll UP → CTA hides, header re-appears.
// Scroll direction is published by nav.js on <html data-scroll-dir>.
function initStickyCta() {
  const cta = qs('.ap-sticky-cta');
  const titleCard = qs('.ap-cd-titlecard');
  if (!cta || !titleCard) return;

  let pastTitle = false;

  if (typeof IntersectionObserver !== 'undefined') {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        pastTitle = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        update();
      });
    }, { threshold: 0, rootMargin: '0px' });
    obs.observe(titleCard);
  }

  function update() {
    const dir = document.documentElement.dataset.scrollDir;
    cta.classList.toggle('is-visible', pastTitle && dir === 'down');
  }

  on(window, 'scroll', update, { passive: true });
  update();
}

export function initListingPage() {
  initGallery();
  initSpecsTabs();
  initFinanceCalc();
  initFuelCalc();
  initStickyCta();

  // Pick 4 similar listings (same body, exclude current)
  const currentId = Number(document.body.dataset.listingId || 0);
  const current = AP_DATA.listings.find((l) => l.id === currentId);
  const similar = AP_DATA.listings
    .filter((l) => l.id !== currentId && (current ? l.body === current.body : true))
    .slice(0, 4);
  renderListingsInto(qs('[data-role="similar-listings"]'), similar, { favs: getFavs() });
}
